import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { TooltipIconWrapperStyled } from 'approot/shared/tooltip/tooltip.style';
import {
  ComponentOverlay,
  ComponentOverlayTooltip,
} from './component-overlay.style';
import IconExpand from 'approot/shared/icons/icon-expand';

type Props = {
  ariaLabel?: string;
  onClick: () => void;
};

const ComponentOverlaySample = ({ ariaLabel, onClick }: Props) => (
  <ComponentOverlayTooltip>
    <TooltipWrapper
      hoverText="Expand"
      svgContent={
        <TooltipIconWrapperStyled>
          <IconExpand width={20} height={20} />
        </TooltipIconWrapperStyled>
      }
    >
      <ComponentOverlay
        type="button"
        aria-label={ariaLabel || 'View responses'}
        aria-haspopup="true"
        onClick={onClick}
      />
    </TooltipWrapper>
  </ComponentOverlayTooltip>
);

export default ComponentOverlaySample;
